<template>
  <main id="main-container">
    <Hero title="Gestión de Empresas" page="Empresas" />

    <div class="content">
      <div class="row">
        
        <div class="col-12">
        <Card title="Registrar Nueva Empresa">
            <form @submit.prevent="createCompany">
            <div class="row">
                <div class="col-md-6">
                <label class="form-label">Nombre de la Empresa</label>
                <input
                    v-model="newCompany.name"
                    type="text"
                    class="form-control"
                    placeholder="Ej: Constructora Alfa"
                    required
                />
                </div>
                <div class="col-md-6">
                <label class="form-label">Asignar Dispositivos Iniciales</label>
                <select
                    v-model="newCompany.devices"
                    class="form-select"
                    multiple
                    style="height: 100px;"
                >
                    <option 
                    v-for="device in availableDevices" 
                    :key="device._id" 
                    :value="device._id"
                    >
                    {{ device.name }} ({{ device.dId }})
                    </option>
                </select>
                <small class="text-muted">Mantén presionado Ctrl (o Cmd) para seleccionar varios.</small>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-end">
                <button type="submit" class="btn btn-primary">
                    <i class="fa fa-plus me-1"></i> Crear Empresa
                </button>
                </div>
            </div>
            </form>
        </Card>
        </div>

        <div class="col-12">
            <Card title="Gestionar Dispositivos por Empresa">
            <div class="row">
                <div class="col-md-4">
                <label class="form-label">Seleccionar Empresa</label>
                <select v-model="selectedCompanyIndex" class="form-select" @change="loadCompanyDevices">
                    <option :value="null">Seleccione una empresa...</option>
                    <option v-for="(company, index) in $store.state.companies" :key="company._id" :value="index">
                    {{ company.name }}
                    </option>
                </select>
                </div>

                <div class="col-md-8" v-if="selectedCompanyIndex !== null">
                <label class="form-label">Dispositivos en esta Empresa</label>
                <div class="table-responsive border p-2 rounded">
                    <table class="table table-sm table-vcenter">
                    <thead>
                        <tr>
                        <th>Nombre</th>
                        <th>ID</th>
                        <th class="text-center">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="devId in $store.state.companies[selectedCompanyIndex].devices" :key="devId">
                        <td>{{ getDeviceName(devId) }}</td>
                        <td>{{ devId }}</td>
                        <td class="text-center">
                            <button 
                            @click="removeDeviceFromCompany(devId)" 
                            class="btn btn-sm btn-alt-danger"
                            title="Quitar de empresa"
                            >
                            <i class="fa fa-times"></i>
                            </button>
                        </td>
                        </tr>
                        <tr v-if="$store.state.companies[selectedCompanyIndex].devices.length === 0">
                        <td colspan="3" class="text-center text-muted">No hay dispositivos asignados</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                
                <div class="mt-3 d-flex gap-2">
                    <select v-model="deviceToAdd" class="form-select">
                    <option :value="null">Agregar nuevo dispositivo...</option>
                    <option v-for="d in availableDevices" :key="d._id" :value="d._id">
                        {{ d.name }}
                    </option>
                    </select>
                    <button @click="addDeviceToCompany" class="btn btn-info" :disabled="!deviceToAdd">
                    Añadir
                    </button>
                </div>
                </div>
            </div>
            </Card>
        </div>

        <div class="col-12">
            <Card title="Zona de Peligro">
            <div class="row">
                <div>
                    <h5 class="mb-0">Eliminar Empresa</h5>
                    <p class="text-muted mb-0 small">Esta acción no desvinculará los dispositivos, solo borrará la entidad empresa.</p>
                    </div>
                    <div class="col-md-6 col-12 mb-2">
                        <select v-model="companyToDelete" class="form-select">
                            <option :value="null">Seleccionar para borrar...</option>
                            <option v-for="company in $store.state.companies" :key="company._id" :value="company._id">
                            {{ company.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6 col-12">
                        <button 
                        class="btn btn-danger" 
                        :disabled="!companyToDelete"
                        @click="deleteCompany"
                        >
                        <i class="fa fa-trash me-1"></i> Eliminar
                    </button>
                    </div>
                </div>
            </Card>
        </div>

    </div>
</div>
</main>
</template>

<script setup>
import useCompany from '@/composables/useCompany';

const {
        newCompany,
        selectedCompanyIndex,
        deviceToAdd,
        companyToDelete,
        availableDevices,
        createCompany,
        deleteCompany,
        removeDeviceFromCompany,
        addDeviceToCompany,
        getDeviceName
} = useCompany()
// Estados


</script>

<style scoped>
.form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.dropdown-header {
  background-color: #f8f9fa;
}
</style>